import { API_BASE } from "../config";
import {
  FaAlignJustify,
  FaAngleDoubleRight,
  FaAngleLeft,
  FaBook,
  FaChartLine,
  FaClone,
  FaComments,
  FaEnvelope,
  FaEnvelopeOpen,
  FaFile,
  FaGavel,
  FaMapSigns,
  FaNewspaper,
  FaRegClone,
  FaRegEnvelope,
  FaRegEnvelopeOpen,
  FaRegQuestionCircle,
  FaShoppingBag,
  FaSignOutAlt,
  FaTachometerAlt,
  FaUser,
  FaUsers,
} from "react-icons/fa";
import logo from "../assets/images/admin.ico";
import styles from "../assets/styles/components/Menu.module.css";
import { useState, useRef, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/userContext";

const Menu = ({ collapsed, mobileOpen }) => {
  const menuRef = useRef(null);
  const [menuHeight, setMenuHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991.98);
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);

  const baivietRef = useRef(null);
  const noidungRef = useRef(null);
  const danhgiaRef = useRef(null);
  const faqsRef = useRef(null);
  const mailRef = useRef(null);
  const trangwebRef = useRef(null);
  const userRef = useRef(null);
  const danhmucRef = useRef(null);
  const dichvuRef = useRef(null);
  const goidichvuRef = useRef(null);
  const dashBoardRef = useRef(null);

  const toggleMenu = (menuName) => {
    setActiveMenu(activeMenu === menuName ? null : menuName);
  };

  const getSubMenuStyle = (ref, menuName) => {
    if (!ref.current) return {};
    return {
      maxHeight:
        activeMenu === menuName ? `${ref.current.scrollHeight}px` : "0",
      overflow: "hidden",
      transition: "max-height 0.3s ease",
    };
  };

  const getMenuStyle = (ref, name) =>
    !collapsed ? getSubMenuStyle(ref, name) : {};

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991.98);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [totalComment2s, setTotalComment2s] = useState([]);
  const [totlatuser, setTotlatuser] = useState(0);
  const [totalfaq, setTotalFaq] = useState(0);
  const [totalComment, setTotalComments] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resCmt, resUsers, resFaq, resCmts] = await Promise.all([
          fetch(`${API_BASE}/Comment2s?status=0&begin=0&take=1`),
          fetch(`${API_BASE}/Users?begin=0&take=1`),
          fetch(`${API_BASE}/Faqs?status=0&begin=0&take=1`),
          fetch(`${API_BASE}/Comments?status=0&begin=0&take=1`),
        ]);

        const dataCmt = await resCmt.json();
        setTotalComment2s(dataCmt?.[0]?.totalRows);

        const dataUsers = await resUsers.json();
        setTotlatuser(dataUsers?.[0]?.totalRows);

        const dataFaq = await resFaq.json();
        setTotalFaq(dataFaq?.[0]?.totalRows);

        const dataCmts = await resCmts.json();
        setTotalComments(dataCmts?.[0]?.totalRows);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  const handleLogout = async () => {
    try {
      const res = await fetch(`${API_BASE}/Login/logout`, {
        method: "POST",
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === 0) {
        setUser(null);
        navigate("/acp/Account/Login");

        window.location.reload();
      }
    } catch (err) {}
  };
  return (
    <>
      <div
        ref={menuRef}
        className={`${styles.wrapperMenu} 
      ${collapsed ? styles.collapsed : ""} 
      ${mobileOpen ? styles.mobileOpen : ""}`}
      >
        <div className={`${styles.wrapper}  ${styles.dsNone} `}>
          <div className={styles.logo}>
            <img src={logo} alt="logo" />
          </div>

          <FaSignOutAlt className={styles.signOut} onClick={handleLogout} />
        </div>

        {/* DashBoard  */}
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "Dashboard" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("Dashboard")}
          >
            <span>
              <FaTachometerAlt />
              <span className={styles.titleMenu}>Trang chủ</span>
            </span>
            <FaAngleLeft
              className={`${styles.icon} ${
                activeMenu === "Dashboard" ? styles.rotate : ""
              }`}
            />
          </div>
          <div
            ref={dashBoardRef}
            style={!collapsed ? getSubMenuStyle(dashBoardRef, "Dashboard") : {}}
            className={styles.subMenuList}
          >
            <Link
              to="/acp/Dashboard/Content"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Dashboard/Content"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaNewspaper />
              <span>Tổng quan nội dung</span>
            </Link>
            {/* <Link
              to="/acp/Dashboard/Lawyer"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Dashboard/Lawyer"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaGavel />
              <span>Hoạt động luật sư</span>
            </Link>
            <Link
              to="/acp/Dashboard/Growth"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Dashboard/Growth"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaChartLine />
              <span>Tăng trưởng & Truy cập</span>
            </Link> */}
          </div>
        </div>
        {/*  */}
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "baiviet" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("baiviet")}
          >
            <span>
              <FaFile />
              <span className={styles.titleMenu}>Bài viết</span>
            </span>
            <FaAngleLeft
              className={`${styles.icon} ${
                activeMenu === "baiviet" ? styles.rotate : ""
              }`}
            />
          </div>
          <div
            ref={baivietRef}
            style={!collapsed ? getSubMenuStyle(baivietRef, "baiviet") : {}}
            className={styles.subMenuList}
          >
            <Link
              to="/acp/Articles"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Articles"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaFile />
              <span>Tất cả bài viết</span>
            </Link>
            <Link
              to="/acp/Articles/Create"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Articles/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm bài viết</span>
            </Link>
          </div>
        </div>
        {/* Noi dung */}
        {/* <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "noidung" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("noidung")}
          >
            <span>
              <FaMapSigns />
              <span className={styles.titleMenu}>Bảng nội dung</span>
            </span>
            <FaAngleLeft
              className={`${styles.icon} ${
                activeMenu === "noidung" ? styles.rotate : ""
              }`}
            />
          </div>

          <div
            ref={noidungRef}
            style={!collapsed ? getSubMenuStyle(noidungRef, "noidung") : {}}
            className={styles.subMenuList}
          >
            <Link
              to="/acp/Banners"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Banners" ? styles.activeSubMenu : ""
              }`}
            >
              <FaMapSigns />
              <span>Tất cả bảng nội dung</span>
            </Link>

            <Link
              to="/acp/Banners/Create"
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Banners/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm bảng nội dung</span>
            </Link>
          </div>
        </div> */}

        <Link
          to={"/acp/Comments"}
          onClick={() => toggleMenu("/acp/Comments")}
          className={`${styles.wrapper} ${styles.menu} ${styles.psRelative} ${
            activeMenu === "/acp/Comments" ? styles.activeMenu : ""
          }`}
        >
          <span>
            <FaComments />
            <span className={styles.titleMenu}>Bình luận</span>
          </span>
          <div className={styles.number}>
            <span>{totalComment}</span>
          </div>
        </Link>
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "danhgia" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("danhgia")}
          >
            <span>
              <FaRegEnvelopeOpen />
              <span className={styles.titleMenu}>Đánh giá</span>
            </span>
            <div className={styles.number}>
              <span>{totalComment2s}</span>
              <FaAngleLeft
                className={`${styles.icon} ${
                  activeMenu === "danhgia" ? styles.rotate : ""
                }`}
              />
            </div>
          </div>
          <div
            ref={danhgiaRef}
            style={!collapsed ? getSubMenuStyle(danhgiaRef, "danhgia") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/Comment2s"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Comment2s"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaRegEnvelope />
              <span>Đánh giá chưa duyệt</span>
            </Link>
            <Link
              to={"/acp/Comment2s/Index1"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Comment2s/Index1"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaRegEnvelopeOpen />
              <span>Đánh giá đã duyệt</span>
            </Link>
            <Link
              to={"/acp/Comment2s/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Comment2s/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm đánh giá</span>
            </Link>
          </div>
        </div>
        <Link
          to={"/acp/Contacts"}
          onClick={() => toggleMenu("/acp/Contacts")}
          className={`${styles.wrapper} ${styles.menu} ${styles.psRelative} ${
            activeMenu === "/acp/Contacts" ? styles.activeMenu : ""
          }`}
        >
          <span>
            <FaRegEnvelope />
            <span className={styles.titleMenu}>Liên hệ</span>
          </span>
        </Link>
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "faqs" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("faqs")}
          >
            <span>
              <FaRegQuestionCircle />
              <span className={styles.titleMenu}>FAQs</span>
            </span>
            <div className={styles.number}>
              <span>{totalfaq}</span>
              <FaAngleLeft
                className={`${styles.icon} ${
                  activeMenu === "faqs" ? styles.rotate : ""
                }`}
              />
            </div>
          </div>
          <div
            ref={faqsRef}
            style={!collapsed ? getSubMenuStyle(faqsRef, "faqs") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/FAQs"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/FAQs" ? styles.activeSubMenu : ""
              }`}
            >
              <FaRegQuestionCircle />
              <span>FAQs</span>
            </Link>
            <Link
              to={"/acp/FAQs/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/FAQs/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm Faq</span>
            </Link>
          </div>
        </div>
        {/*  */}
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "mail" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("mail")}
          >
            <span>
              <FaRegEnvelope />
              <span className={styles.titleMenu}>Mails</span>
            </span>
            <FaAngleLeft
              className={`${styles.icon} ${
                activeMenu === "mail" ? styles.rotate : ""
              }`}
            />
          </div>
          <div
            ref={mailRef}
            style={!collapsed ? getSubMenuStyle(mailRef, "mail") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/Mails"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Mails" ? styles.activeSubMenu : ""
              }`}
            >
              <FaRegEnvelope />
              <span>Tất cả mails</span>
            </Link>
            <Link
              to={"/acp/Mails/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Mails/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm mails</span>
            </Link>
          </div>
        </div>
        {/* <Link
          to={"/acp/Orders"}
          onClick={() => toggleMenu("/acp/Orders")}
          className={`${styles.wrapper} ${styles.menu} ${styles.psRelative} ${
            activeMenu === "/acp/Orders" ? styles.activeMenu : ""
          }`}
        >
          <span>
            <FaShoppingBag />
            <span className={styles.titleMenu}>Orders</span>
          </span>
        </Link> */}

        {/* <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "trangweb" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("trangweb")}
          >
            <span>
              <FaRegClone />
              <span className={styles.titleMenu}>Trang</span>
            </span>
            <FaAngleLeft
              className={`${styles.icon} ${
                activeMenu === "trangweb" ? styles.rotate : ""
              }`}
            />
          </div>
          <div
            ref={trangwebRef}
            style={!collapsed ? getSubMenuStyle(trangwebRef, "trangweb") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/Pages"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Pages" ? styles.activeSubMenu : ""
              }`}
            >
              <FaRegClone />
              <span>Tất cả trang</span>
            </Link>
            <Link
              to={"/acp/Pages/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Pages/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm trang</span>
            </Link>
          </div>
        </div> */}
        <Link
          to="/acp/Banner_user_image"
          className={`${styles.wrapper} ${styles.menu} ${styles.psRelative} ${
            location.pathname.startsWith("/acp/Banner_user_image")
              ? styles.activeMenu
              : ""
          }`}
        >
          <span>
            <FaClone />
            <span className={styles.titleMenu}>Banner</span>
          </span>
        </Link>
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "user" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("user")}
          >
            <span>
              <FaUser />
              <span className={styles.titleMenu}>Users & Groups</span>
            </span>
            <div className={styles.number}>
              <span>{totlatuser}</span>
              <FaAngleLeft
                className={`${styles.icon} ${
                  activeMenu === "user" ? styles.rotate : ""
                }`}
              />
            </div>
          </div>
          <div
            ref={userRef}
            style={!collapsed ? getSubMenuStyle(userRef, "user") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/Users"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Users" ? styles.activeSubMenu : ""
              }`}
            >
              <FaUser />
              <span>Tất cả người dùng</span>
            </Link>
            <Link
              to={"/acp/Groups"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Groups" ? styles.activeSubMenu : ""
              }`}
            >
              <FaUsers />
              <span>Nhóm người dùng</span>
            </Link>
          </div>
        </div>
        <Link
          to={"/acp/UserBanner"}
          onClick={() => toggleMenu("/acp/UserBanner")}
          className={`${styles.wrapper} ${styles.menu} ${styles.psRelative} ${
            activeMenu === "/acp/UserBanner" ? styles.activeMenu : ""
          }`}
        >
          <span>
            <FaEnvelopeOpen />
            <span className={styles.titleMenu}>Quảng cáo</span>
          </span>
          <div className={styles.number}>{/* <span>3232</span> */}</div>
        </Link>
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "danhmuc" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("danhmuc")}
          >
            <span>
              <FaBook />
              <span className={styles.titleMenu}>Danh mục</span>
            </span>
            <FaAngleLeft
              className={`${styles.icon} ${
                activeMenu === "danhmuc" ? styles.rotate : ""
              }`}
            />
          </div>
          <div
            ref={danhmucRef}
            style={!collapsed ? getSubMenuStyle(danhmucRef, "danhmuc") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/Categories"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Categories"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaBook />
              <span>Tất cả danh mục</span>
            </Link>
            <Link
              to={"/acp/Categories/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/Categories/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm danh mục</span>
            </Link>
          </div>
        </div>
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "dichvu" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("dichvu")}
          >
            <span>
              <FaBook />
              <span className={styles.titleMenu}>Dịch vụ pháp lý</span>
            </span>
            <div className={styles.number}>
              {/* <span>3232</span> */}
              <FaAngleLeft
                className={`${styles.icon} ${
                  activeMenu === "dichvu" ? styles.rotate : ""
                }`}
              />
            </div>
          </div>
          <div
            ref={dichvuRef}
            style={!collapsed ? getSubMenuStyle(dichvuRef, "dichvu") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/DichVuPhapLy"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/DichVuPhapLy"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaBook />
              <span>Dịch vụ pháp lý</span>
            </Link>
            <Link
              to={"/acp/DichVuPhapLy/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/DichVuPhapLy/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm dịch vụ pháp lý</span>
            </Link>
            <Link
              to={"/acp/DichVuPhapLy_TuVan"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/DichVuPhapLy_TuVan"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaBook />
              <span>Tư vấn</span>
            </Link>
          </div>
        </div>
        <div className={styles.psRelative}>
          <div
            className={`${styles.wrapper} ${styles.menu} ${
              activeMenu === "goidichvu" ? styles.activeMenu : ""
            }`}
            onClick={() => toggleMenu("goidichvu")}
          >
            <span>
              <FaBook />
              <span className={styles.titleMenu}>Gói dịch vụ</span>
            </span>
            <div className={styles.number}>
              {/* <span>3232</span> */}
              <FaAngleLeft
                className={`${styles.icon} ${
                  activeMenu === "goidichvu" ? styles.rotate : ""
                }`}
              />
            </div>
          </div>
          <div
            ref={goidichvuRef}
            style={!collapsed ? getSubMenuStyle(goidichvuRef, "goidichvu") : {}}
            className={styles.subMenuList}
          >
            <Link
              to={"/acp/GoiDichVu"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/GoiDichVu"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaBook />
              <span>Danh sách gói dịch vụ</span>
            </Link>
            <Link
              to={"/acp/GoiDichVu/Create"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/GoiDichVu/Create"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Thêm gói dịch vụ</span>
            </Link>
            <Link
              to={"/acp/GoiDichVu_khuvuc"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/GoiDichVu_khuvuc"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaAngleDoubleRight />
              <span>Gói dịch vụ khu vực</span>
            </Link>
            {/* <Link
              to={"/acp/GoiDichVu_datgoi"}
              className={`${styles.subMenu} ${
                location.pathname === "/acp/GoiDichVu_datgoi"
                  ? styles.activeSubMenu
                  : ""
              }`}
            >
              <FaBook />
              <span>Danh sách đặt gói</span>
            </Link> */}
          </div>
        </div>
        <Link
          to={"/acp/Lawyer_SEO"}
          onClick={() => toggleMenu("/acp/Lawyer_SEO")}
          className={`${styles.wrapper} ${styles.menu} ${styles.psRelative} ${
            activeMenu === "/acp/Lawyer_SEO" ? styles.activeMenu : ""
          }`}
        >
          <span>
            <FaAlignJustify />
            <span className={styles.titleMenu}>SEO lĩnh vực</span>
          </span>
        </Link>
      </div>
    </>
  );
};

export default Menu;
